import { Drawer } from "antd";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { CgNotes } from "react-icons/cg";
import DockerNoteContainer from "./DockerNoteContainer";
import DockerLogHeader from "./DockerLogHeader";
type Props = {
  className?: string;
};

const SubjectScreeningHeaderSecondColumn = (props: Props) => {
  const { t } = useTranslation();
  const { className } = props;
  const [doctorNoteModal, setDoctorNoteModal] = useState<boolean>(false);
  const handleModal = () => {
    setDoctorNoteModal(true);
  };
  const handleClose = () => {
    setDoctorNoteModal(false);
  };
  return (
    <div className={`details_second_colum  details_second_column_${className}`}>
      {!className &&
      <div className="subject_doc_notes_first_colum">
          <span className="details_last_screening_text">
            {t("doctor_notes")}
          </span>
        </div>}
      
      <div
        className="subject_doc_notes_second_colum"
        onClick={handleModal}
        style={{ display: doctorNoteModal ? "none" : "" }}>
        
        <CgNotes className="doc_note_icon" />
      </div>
      <Drawer
        open={doctorNoteModal}
        onClose={handleClose}
        title={<DockerLogHeader />}>
        
        <DockerNoteContainer />
      </Drawer>
    </div>);

};

export default SubjectScreeningHeaderSecondColumn;